import Super from 'client-portal/controllers/-request/date';
import classic from 'ember-classic-decorator';

@classic
export default class SiteRequestDate extends Super {}
